import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Loader } from "../../shared";
import { Helper } from "../../../utils";
import { countryObj } from "../../../utils/countryName";

const Profile = () => {
    const currentUser = useSelector((state) => state.users.currentUser);
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1);
    };

    const [profileInfo, setProfileInfo] = useState({});

    useEffect(() => {
        if (currentUser) {
            const { email, firstName, lastName, phone, country } = currentUser;

            setProfileInfo({
                email,
                firstName,
                lastName,
                phone,
                country,
            });
        }
    }, [currentUser]);

    if (!currentUser) {
        return <Loader />;
    }

    return (
        <>
            <Link to="#" onClick={handleGoBack} className="btn btn-outline-primary mb-5">
                Back
            </Link>
            <div className="card">
                <div className="card-header border-bottom-0 d-flex justify-content-between">
                    <h4 className="d-flex justify-content-between mb-0">Your Profile</h4>
                    <Link to="/update-password" className="btn btn-primary" title="Update Password">
                        Update Password
                    </Link>
                </div>
                <div className="card-body">
                    {Object.keys(profileInfo).map((key, index) =>
                        key === "country" && profileInfo.country.length > 0 ? (
                            <div key={key} className={`row ${index !== 0 ? "mt-4" : ""}`}>
                                <div className="col-md-4">
                                    <strong>{Helper.splitCamelCase(key)}</strong>
                                </div>
                                <div className="col-md-8 d-flex flex-wrap" style={{ gap: "10px" }}>
                                    <span>:</span>
                                    {profileInfo.country.map((item, i) => (
                                        <span
                                            key={i}
                                            className="alert--customize px-3 d-inline-flex align-items-center mr-0"
                                        >
                                            {countryObj[item] || item}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        ) : (
                            <div key={key} className={`row ${index !== 0 ? "mt-4" : ""}`}>
                                <div className="col-md-4">
                                    <strong>{Helper.splitCamelCase(key)}</strong>
                                </div>
                                <div className="col-md-8">: {profileInfo[key]}</div>
                            </div>
                        )
                    )}
                </div>
            </div>
        </>
    );
};

export default Profile;
